export enum direction {
    TOP = "TOP",
    BOTTOM = "BTN"
}
